export const getAllSpProfileDetailsURI = `/partner/sp/allSpProfileDetails`;
export const onboardSpUri =`/partner/sp/onboard`;
export const spProfileDetailsUri = (spId: string)=>`/partner/sp/${spId}/profileDetails`;
export const spPocDetailsUri = (spId: string)=>`/partner/sp/${spId}/pocDetails`;
export const spCompanyDetailsUri = (spId: string)=>`/partner/sp/${spId}/companyDetails`;
export const spPaymentDetailsUri = (spId: string)=>`/partner/sp/${spId}/paymentDetails`;
export const updateSpProfileStatusUri = (spId: string)=>`/partner/spId/${spId}/profileStatus`
export const getSpConfigDetailsUri = (partnerId: string)=>`/partner/sp/${partnerId}/configDetails`

export const getAllDpProfileDetailsURI = `/partner/dp/allDpProfileDetails`;
export const onboardDpUri =`/partner/dp/onboard`;
export const dpProfileDetailsUri = (dpId: string)=>`/partner/dp/${dpId}/profileDetails`;
export const dpPocDetailsUri = (dpId: string)=>`/partner/dp/${dpId}/pocDetails`;
export const dpCompanyDetailsUri = (dpId: string)=>`/partner/dp/${dpId}/companyDetails`;
export const updateDpProfileStatusUri = (dpId: string)=>`/partner/dpId/${dpId}/profileStatus`
export const getDpConfigDetailsUri = (partnerId: string)=>`/partner/dp/${partnerId}/configDetails`